import React, { useRef, useState, useEffect } from 'react'
import { Button } from "../Button"
import { IDCard } from '../IDCard/IDCard'
import { CenteredSpinner } from '../CenteredSpinner'
import { Container, Card } from 'react-bootstrap'
import ReactToPrint from 'react-to-print'
import { getCoverage } from '@angle/utils'
import { ClarityCard, type ClarityCardData } from './ClarityCard'

export const IDCardContainer: React.FC<{
  isLoading: boolean
  data: any
  isDependent?: boolean
}> = ({ isLoading, data }) => {
  const cardRef = useRef<any>()
  const [clarityCardData, setClarityCardData] = useState<ClarityCardData>(null)
  const planCoverage = getCoverage(data)

  if (data?.member_id && data.member_id.length === 12) {
    data.member_id = data.member_id.substring(0, 10)
  }

  useEffect(() => {
    if (data?.clarity_card_information) {
      setClarityCardData(data.clarity_card_information)
    }
  }, [isLoading, data])

  return (
    <Container>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          {planCoverage ? (
            <>
              {clarityCardData ? (
                <ClarityCard clarityCardData={clarityCardData} />
              ) : (
                <div>
                  <div ref={cardRef}>
                    <IDCard data={data} />
                  </div>
                  <ReactToPrint
                    trigger={() => (
                      <div className="text-center mt-4">
                        <Button>Print card</Button>
                      </div>
                    )}
                    content={() => cardRef.current}
                  />
                </div>
              )}
            </>
          ) : (
            <Card>
              <Card.Body className="text-center">
                This member does not currently have coverage.
              </Card.Body>
            </Card>
          )}
        </>
      )}
    </Container>
  )
}
